import gql from 'graphql-tag';

import weightByRoleByIndustryFragment from './weightByRoleByIndustryFragment';

export const dictionaryDokkioTagFragment = gql`
  fragment dictionaryDokkioTagFragment on DictionaryDokkioTag {
    dokkioClass
    name
    description
    icon
    autoApplyConfidenceThreshold
    dokkioLabelName
    appliesToTypes
    blacklistNames
    synonyms
    weightByRoleByIndustry {
      ...weightByRoleByIndustryFragment
    }
  }
  ${weightByRoleByIndustryFragment}
`;
export default dictionaryDokkioTagFragment;
